
export function useTabs(availableTabs, currentRoute) {
  function getActiveTab() {
    let selectedTab = currentRoute.params.tab
    if (!selectedTab && currentRoute.meta.defaultTab) {
      selectedTab = currentRoute.meta.defaultTab
    }
    return availableTabs.find((tab) => tab.id === selectedTab)
  }

  return {
    getActiveTab,
  }
}
